// @flow
import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import CssBaseline from "@material-ui/core/CssBaseline";
import Button from "@material-ui/core/Button";
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
}));

const AdapterLink = React.forwardRef((props, ref) => <Link innerRef={ref} {...props} />);

const ErrorInfo = ({ code, message }) => {
  const classes = useStyles();

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        {code !== "" && (
          <Typography component="h1" variant="h5">
            {code}
          </Typography>
        )}
        <div className="message">{message}</div>
        <Box mt={5}>
          <Button className="submit" color="primary" variant="contained" component={AdapterLink} to="/">
            홈으로
          </Button>
        </Box>
        
      </div>
    </Container>
  );
};

ErrorInfo.defaultProps = {
  message: "오류가 발생했습니다",
  code: ""
};

export default ErrorInfo;
